module.exports = __webpack_public_path__ + "img/ax-logo.2c449312.png";